<template>
  <div class="PasswordForgot">
    <section-header heading="2" ja="パスワードを忘れた場合"/>
    <p class="description">登録したメールアドレスに、再設定用のメールを送ります。</p>
    <p class="description">※未登録のメールアドレスの場合エラーとなります</p>
    <div class="mailadress-text-field">
      <p-text-field
        placeholder="メールアドレス"
        v-model="local">
      </p-text-field>
      <rule v-if="domain === 'それ以外'">@以降も全て入力してください</rule>
      <p-select
        :items="domains"
        v-model="domain">
      </p-select>
    </div>
    <normal-btn @click="onSend" :disabled="!validForm">パスワード再設定メールを送る</normal-btn>
  </div>
</template>

<script>
import NormalBtn from '../components/NormalBtn'
import PSelect from '../components/PSelect'
import PTextField from '../components/PTextField'
import SectionHeader from '../components/SectionHeader'
import Rule from '../components/Rule'
import Protobuf from '../mixins/protobuf.js'
import Screen from '../mixins/screen.js'
import { domains } from "../assets/js/domain";

const pb = require('../assets/js/kumaproto').kuma.jp.protobuf.web

export default {
  name: "PasswordForgot",
  components: {
    NormalBtn,
    PSelect,
    PTextField,
    SectionHeader,
    Rule
  },
  mixins: [Protobuf, Screen],
  data() {
    return {
      description: 'パスワード再設定説明',
      local: '',
      domain: '@docomo.ne.jp',
      domains: domains,
    }
  },
  computed: {
    mailAddress() {
      if(this.domain === 'それ以外') {
        return this.local
      } else {
        return this.local + this.domain
      }
    },
    validForm() {
      return 0 < this.local.length && this.local.length < 258
    }
  },
  methods: {
    onLocalCancel () {
      this.local = ''
    },
    onSetting() {
      this.$router.push("/setting")
    },
    onSend() {
      const cmdNo = pb.PlayerResetPassMailReq.CommandNo.COMMAND_NO
      const message = pb.PlayerResetPassMailReq.create({
        mailAddress: this.mailAddress
      })
      const encoded = pb.PlayerResetPassMailReq.encode(message).finish()
      this.post(cmdNo, encoded)
        .then(decoded => {
          if (decoded.status === pb.PlayerResetPassMailResp.Status.SUCCESS) {
            alert( "確認メールを送信しました。")
          } else {
            this.$_error('Error', { title: 'メールアドレス入力', statusCode: 100 })
          }
        })
        .catch(() => {
          this.$_error('Error', { title: 'メールアドレス入力', statusCode: 100 })
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.description {
  font-size: 12px;
  margin: 20px auto;
  text-align: center;
  white-space: pre-wrap;
  max-width: 90%;
}
.textArea {
  margin: 30px 30px 0;
  font-size: 12px;
  color: #373737;
  p {
    margin-top: 1em;
  }
}
</style>
